import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container } from '@material-ui/core';
import { FormHub, useFormEvents, useObservable, LoadingIndicator, Feedback } from '@lib/common';
import { guestReportQuery, GuestReportForms, guestReportService } from '@lib/state';
import { MaintentanceTicketForm } from 'app/feedback/components';
import { SubmitFeedbackFormFields } from 'app/feedback/models/submitFeedbackFormFields';

// Matches GuestReportNotesMaxLength in property-api.
const NOTES_MAX_LENGTH = 1000;

export const GuestReportPage: React.FC<RouteComponentProps<{
  propertyId: string;
  userId: string;
  reservationId: string;
}>> = ({ match }) => {
  const { propertyId, userId, reservationId } = match.params;

  const report = useObservable(guestReportQuery.report);
  const maintenanceTicketNumber = useObservable(guestReportQuery.maintenanceTicketNumber);

  const [{ error: startError }] = useFormEvents(GuestReportForms.StartGuestReport);
  const [{ status, error }, resetSubmit] = useFormEvents(GuestReportForms.SubmitGuestReport);

  useEffect(() => {
    resetSubmit();
    guestReportService.reset();
    guestReportService.startGuestReport(propertyId, { userId, reservationId });
  }, [propertyId, userId, reservationId, resetSubmit]);

  const submit = useCallback(
    ({ notes, photo }: SubmitFeedbackFormFields) => {
      guestReportService.submitGuestReport(propertyId, userId, reservationId, notes, photo?.[0]);
    },
    [propertyId, userId, reservationId]
  );

  if (startError) {
    return (
      <Feedback show={true} severity="error">
        {startError.message}
      </Feedback>
    );
  }

  if (!report) return <LoadingIndicator fillContainer />;

  return (
    <Container maxWidth="md">
      <FormHub onSubmit={submit}>
        <MaintentanceTicketForm
          status={status}
          error={error}
          qrcode={{ name: report.name, location: report.location }}
          maintenanceTicketNumber={maintenanceTicketNumber}
          notesMaxLength={NOTES_MAX_LENGTH}
        />
      </FormHub>
    </Container>
  );
};
